export default [
    {
        path: '/eventos',
        name: 'eventos',
        component: () => import(/* webpackChunkName: "home" */ './Eventos')
    }
]
